import PropTypes from "prop-types";
import { Chip } from "@material-ui/core";
import { Lock as LockIcon } from "@material-ui/icons";

const InternalNoteTag = ({ size = "small" }) => (
  <Chip
    icon={<LockIcon style={{ fontSize: 14, color: "#F57C00" }} />}
    label="Internal Note"
    size={size}
    sx={{
      backgroundColor: "#FFF8E1",
      color: "#F57C00",
      fontWeight: 600,
      fontSize: 10,
      textTransform: "uppercase",
      letterSpacing: 0.5,
      borderRadius: "4px",
    }}
  />
);

InternalNoteTag.propTypes = {
  size: PropTypes.string,
};

export default InternalNoteTag;
